import { createAction, props } from '@ngrx/store';
import { DevicesResponse } from '../../../api/models/admin/admin-device.model';


export const getDevicesAction = createAction(
    '[Admin Devices Page] Get Devices list',
        props<{
            deviceTypes: {
                id: string;
                value: string;
                selected: boolean;
            }[],
            searchString: string,
            pagination: {
                pageNumber: number;
                pageSize: number;
            }}>()
);

export const searchDevicesAction = createAction(
    '[Admin Devices Page] Search Devices list',
        props<{
            deviceTypes: {
            id: string;
            value: string;
            selected: boolean;
        }[],
        searchString: string,
        pagination: {
            pageNumber: number;
            pageSize: number;
        }}>()
);

export const setDevicesAction = createAction(
    '[Admin Devices Page] Set Devices list',
    props<{ devicesResponse: DevicesResponse, searchString: string}>()
);

export const setDevicesActionFail = createAction(
    '[Admin Devices Page] Set Devices list failed',
    props<{ error:any}>()
);

export const clearDevicesAction = createAction(
    '[Admin Devices Page] Clear Devices list'
);

export const clearDeviceSearchStringAction = createAction(
    '[Admin Devices Page] Clear Devices SearchString'
);

export const devicesActionTypes = {
    getDevicesAction,
    searchDevicesAction,
    setDevicesAction,
    setDevicesActionFail,
    clearDevicesAction,
    clearDeviceSearchStringAction
}

